import { createUseStyles } from 'react-jss';

export const usePublicLayoutStyles = createUseStyles({
  pageContainer: {
    paddingTop: 90
  }
});
